<!--================================= Header Start =================================-->
<div class="header-main" [class.sticky]="isSticky()" [class.hidden]="isHidden()">
  <div class="header-inner">
    <nav class="navbar navbar-expand-lg" [class.border-0]="router.url.includes('/' + ROUTES.ACCOUNT.ROOT)">
      <div class="container-fluid">
        <!--  Mobile & Tablet View -->
        <!-- Logo (Navbar Brand) -->
        <a class="navbar-brand d-none" routerLink="/">
          <img [src]="s3BucketImageURL + '/ASSETS/GENERAL/LOGO/responsive-logo.svg'" width="23" height="35"
            alt="GatherCo" appHandleImageError />
        </a>
        <!-- Logo (Navbar Brand) -->
        <!-- Right-Side Menu -->
        <div class="right-side-manu d-none">
          <div class="d-flex align-items-center" role="search">
            <!-- Search Box -->
            @if (showSearchBar) {
            <div class="search-icon" [class.mobile-icon-hide]="isUserAuthenticated">
              <input #searchInput type="search" placeholder="Search" class="search-box"
                (focus)="isSearchActive.set(true)"
                (keydown.enter)="onSearch($event, searchInput.value); isSearchActive.set(false)"
                (blur)="isSearchActive.set(false)" />
            </div>
            }
            <!-- Signed-in icons, or the Sign In button for non-authenticated users -->
            @if (isUserAuthenticated) {
            <ng-container *ngTemplateOutlet="searchIcons; context: { $implicit: true }"></ng-container>
            } @else {
            <div class="responsive-sign-in-btn">
              <ng-container *ngTemplateOutlet="signIn"></ng-container>
            </div>
            }
          </div>
          <!-- Navbar Toggler for Mobile View -->
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" #menuIcon
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
        <!-- Right-Side Menu -->
        <!--  Mobile & Tablet View -->

        <!-- Desktop View -->
        <!-- Main Navbar Content -->
        <div class="collapse navbar-collapse justify-content-between align-item-center navbar-list"
          id="navbarSupportedContent">
          <!-- Navbar Brand -->
          <a class="navbar-brand" routerLink="/">
            <img [src]="s3BucketImageURL + '/ASSETS/GENERAL/LOGO/gatherco-logo.svg'" width="143" height="55"
              alt="GatherCo" appHandleImageError />
          </a>
          <ul class="navbar-nav mb-2 mb-lg-0" [class.hide-nav]="isSearchActive()">
            @if (isUserAuthenticated) {
            <li class="nav-item d-none">
              <a class="nav-link" (click)="toggleMenu()"
                [routerLink]="[ROUTES.ACCOUNT.ROOT+'/'+ROUTES.ACCOUNT.DASHBOARD]" routerLinkActive="active">
                Dashboard
              </a>
            </li>
            }
            <li class="nav-item">
              <a class="nav-link" routerLink="flooring" (click)="toggleMenu()"
                (mouseover)="onMouseEnterMenu('flooring', $event)" routerLinkActive="active"
                aria-current="page">Flooring</a>
              <ng-container
                *ngTemplateOutlet="megaMenu; context: { type: 'Flooring', collections: flooringCollectionList, typeName: flooringTypeName }"></ng-container>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="walling" (click)="toggleMenu();"
                (mouseover)="onMouseEnterMenu('walling', $event)" routerLinkActive="active">Walling</a>
              <ng-container
                *ngTemplateOutlet="megaMenu; context: { type: 'Walling', collections: wallingCollectionList, typeName: wallingTypeName }"></ng-container>
            </li>
            <li class="nav-item custom-dropdown" [routerLinkActive]="'is-active'"
              [routerLinkActiveOptions]="{ exact: false }">
              <div class="dropdown">
                <a href="" class="nav-link manu-icon dropdown-toggle" id="aboutUsDropdown" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  About Us
                </a>
                <ul class="dropdown-menu" aria-labelledby="aboutUsDropdown" (click)="toggleMenu()">
                  @for (item of dropDownList; track item.title) {
                  <li><a class="dropdown-item" [routerLink]="item.route" routerLinkActive="active">{{item.title}}</a>
                  </li>
                  }
                </ul>
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link" (click)="toggleMenu()" routerLink="projects" routerLinkActive="active">
                Projects
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="sample-request" (click)="toggleMenu()" routerLinkActive="active">
                Sample Request
              </a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" (click)="isUserAuthenticated ? handlePriceListClick() : null" [routerLink]="isUserAuthenticated ? [ROUTES.PRICE_LIST] : null" routerLinkActive="active" [class.grey-price-menu]="!isUserAuthenticated" placement="auto" [ngbTooltip]="!isUserAuthenticated ? CommonConstants.PRICE_MENU_TOOLTIP_MESSAGE : ''">
                Price List
              </a>
            </li> -->
            <li class="nav-item">
              @if (isUserAuthenticated) {
              <a class="nav-link" (click)="handlePriceListClick()" [routerLink]="[ROUTES.PRICE_LIST]"
                routerLinkActive="active">
                Price List
              </a>
              } @else {
              <span class="nav-link grey-price-menu" placement="auto"
                [ngbTooltip]="CommonConstants.PRICE_MENU_TOOLTIP_MESSAGE">
                Price List
              </span>
              }
            </li>

            <li class="nav-item">
              <a class="nav-link outlet" (click)="toggleMenu()" [routerLink]="[ROUTES.OUTLET.ROOT]"
                routerLinkActive="active">
                Outlet
              </a>
            </li>
            @if (isUserAuthenticated) {
            <ng-container *ngTemplateOutlet="dropdown; context: { $implicit: true }"></ng-container>
            }
          </ul>
          <!-- Navbar Links -->
          <!-- Search and User Icons -->
          <div class="d-flex align-items-center navbar-right" role="search" [class.expanded-search]="isSearchActive()">
            <!-- Ahead of the search box, not after it. Rendered here rather than inside
                 #searchIcons because that template sits to the RIGHT of the search box on
                 desktop - the mobile header, where #searchIcons owns its own search input,
                 already has the chip first. -->
            @if (isUserAuthenticated) {
            <ng-container *ngTemplateOutlet="askPebbl"></ng-container>
            }
            @if (showSearchBar) {
            <div class="search-icon">
              <input #searchValue type="search" placeholder="Search" class="search-box"
                (focus)="isSearchActive.set(true);" (blur)="isSearchActive.set(false);"
                (keyup.enter)="onSearch($event, searchValue.value);  isSearchActive.set(false)" />
            </div>
            }
            <!-- Authentication Buttons -->
            @if (isUserAuthenticated) {
            <ng-container *ngTemplateOutlet="searchIcons"></ng-container>
            } @else {
            <ng-container *ngTemplateOutlet="signIn"></ng-container>
            }
          </div>
        </div>
        <!-- Main Navbar Content -->
        <!-- Desktop View -->
        <ng-template #megaMenu let-type="type" let-collections="collections" let-typeName="typeName">
          <div class="mega-menu">
            <div class="mega-menu-inner">
              <div class="left-side">
                <a [routerLink]="type.toLowerCase()" class="mega-menu-link" (click)="toggleMegaMenu($event)">All
                  {{type}}
                  <img [src]="s3BucketImageURL + '/ASSETS/GENERAL/ICONS/right-arrow-icon.svg'" width="18" height="14"
                    alt="Right Arrow Icon" appHandleImageError>
                </a>
              </div>
              <div class="right-side">
                <ul class="right-side-content">
                  @if (collections && collections.length > 0) {
                    @for (collection of collections; track collection.name) {
                      <li class="menu-nav-item">
                        <a class="menu-nav-link" (click)="toggleMegaMenu($event)"
                          [routerLink]="['/'+ utilityService.createSlug(typeName)+'/'+utilityService.createSlug(collection.name)]">
                          {{ collection.name }}
                        </a>
                      </li>
                    }
                  } @else {
                    <li>No data found.</li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #searchIcons let-show>
          <div class="search-icons d-flex align-items-center ms-2">
            <ng-container
              *ngTemplateOutlet="gathercoCredit; context: { $implicit: show ? true : false }"></ng-container>
            <!-- Stands where the credit pill does, and while that pill is switched off it is the
                 only thing in that slot - see showGathercoCredit in the component.
                 `show` is only set by the mobile/tablet header, which is the one whose search
                 input lives inside this template; the desktop header renders the chip itself,
                 ahead of its own search box. Without this guard it would appear twice there. -->
            @if (show) {
            <ng-container *ngTemplateOutlet="askPebbl"></ng-container>
            }
            @if (showSearchBar && show) {
            <div class="search-icon mobile-icon-show">
              <input #searchInput type="search" placeholder="Search" class="search-box"
                (focus)="isSearchActive.set(true);" (blur)="isSearchActive.set(false);"
                (keydown.enter)="onSearch($event, searchInput.value);  isSearchActive.set(false);" />
            </div>
            }
            @for (icon of iconList; track icon.title) {
              @if (icon.title!='Samples' || (icon.title=='Samples' && sampleOrderCount() && !subscriberService.sampleOrderError())) {
                <a routerLinkActive="active" class="manu-icon"
                  [class.mobile-icon-hide]="icon.title=='Trade Dashboard' && show" [routerLink]="icon.route" (click)="icon.title=='Samples' ? openSampleOrderModal() : null">
                  <img [src]="s3BucketImageURL + icon.icon" [width]="icon.width ? icon.width : show ? 24 : 22"
                    [height]="show ? 24 : 22" [alt]="icon.title" class="icon" [title]="icon.title" />
                  @if(icon.title=='Samples') {
                  <span class="badges">{{ sampleOrderCount() }}</span>
                  }
                  @if(icon.count) {
                  <span class="badges">{{ icon.count }}</span>
                  }
                </a>
              }
            }
            <!-- User Profile Dropdown -->
            <div class="dropdown d-inline-block dropstart" [class.mobile-icon-hide]="show">
              <a href="" class="manu-icon dropdown-toggle" title="User Profile" id="userDropdown"
                data-bs-toggle="dropdown" aria-expanded="false">
                <img [src]="s3BucketImageURL + '/ASSETS/GENERAL/ICONS/user-icon.svg'" [width]="show ? 24 : 22"
                  [height]="show ? 24 : 22" alt="User Icon" class="icon" />
              </a>
              <ul class="dropdown-menu" aria-labelledby="userDropdown">
                <ng-container *ngTemplateOutlet="dropdown"></ng-container>
              </ul>
            </div>
          </div>
        </ng-template>
        <ng-template #gathercoCredit let-showClass>
          <!-- showGathercoCredit is a temporary off switch, not a replacement for the existing
               CREDIT_EARN check - both have to pass for the pill to render, so putting it back is
               one boolean in the component. -->
          @if(showGathercoCredit && isCreditEarnDisabled==CommonConstants.CREDIT_EARN.SHOW){
          <div class="gatheco-credit-box">
            <a class="gatheco-credit" [class.custom-margin]="!showSearchBar && showClass"
              [routerLink]="[ROUTES.ACCOUNT.ROOT + '/' + ROUTES.ACCOUNT.THE_GATHER_COMMITMENT]" placement="bottom"
              ngbTooltip="GatherCo Credit">
              <img [src]="s3BucketImageURL + '/ASSETS/GENERAL/ICONS/credit-coin-icon.svg'" loading="lazy"
                alt="Credit Icon" width="22" height="22" title="GatherCo Credit">
              <label class="credit-label"><span class="credit-content"> </span><strong class="credit">{{
                  gathercoCreditCount | currency
                  }}</strong></label>
            </a>
          </div>
          }
        </ng-template>
        <!-- Straight to the full-window assistant, not the floating panel: this sits in the same
             slot the credit pill used and is the signed-in customer's route into Pebbl from any
             page. Only ever rendered inside #searchIcons, which is itself signed-in only - and
             /ask-pebbl is auth-guarded, so a guest could not follow it anyway. -->
        <ng-template #askPebbl>
          <div class="pebbl-chip-box">
            <a class="pebbl-chip" [routerLink]="['/' + ROUTES.ASK_PEBBL]" placement="bottom"
              ngbTooltip="Ask Pebbl AI" title="Ask Pebbl AI">
              <!-- THE PEBBL MARK. Identical construction to the launcher glyph (.ai-chat-spark)
                   and the panel badge asset: the same three paths on the same 20-unit design box,
                   in the same order, on the same 1.6 stroke. It used to carry only the top-right
                   sparkle, so the header's mark was a different glyph from the two the widget
                   shows - all three sparkle positions belong to the mark. Sized 20 rather than 18
                   so the stroke lands at ~1.45px, the weight every other glyph in this header
                   renders at.
                   DUOTONE: the star rides currentColor (the chip's green); the two sparkles are
                   classed so the stylesheet inks them $pebblBrass - the same pairing the launcher
                   and the panel badge carry, so the three marks stay one logo. -->
              <svg class="pebbl-chip-spark" width="20" height="20" viewBox="-1 -1 22 22"
                fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
                stroke-linejoin="round" aria-hidden="true">
                <path class="pebbl-chip-spark-main" d="M8.14174 13.1499C8.06139 12.8385 7.89905 12.5542 7.67161 12.3268C7.44417 12.0993 7.15993 11.937 6.84847 11.8567L1.32712 10.4329C1.23292 10.4062 1.15001 10.3494 1.09098 10.2713C1.03194 10.1932 1 10.0979 1 10C1 9.90208 1.03194 9.80683 1.09098 9.72871C1.15001 9.65058 1.23292 9.59385 1.32712 9.56711L6.84847 8.14245C7.15982 8.06217 7.44398 7.89997 7.67141 7.67269C7.89885 7.44542 8.06125 7.16137 8.14174 6.85008L9.5655 1.32872C9.59197 1.23414 9.64865 1.15083 9.72689 1.09148C9.80513 1.03213 9.90064 1 9.99884 1C10.097 1 10.1926 1.03213 10.2708 1.09148C10.349 1.15083 10.4057 1.23414 10.4322 1.32872L11.855 6.85008C11.9354 7.16153 12.0977 7.44577 12.3252 7.67321C12.5526 7.90066 12.8369 8.063 13.1483 8.14335L18.6697 9.56621C18.7646 9.5924 18.8483 9.64902 18.908 9.72737C18.9677 9.80573 19 9.90151 19 10C19 10.0985 18.9677 10.1943 18.908 10.2726C18.8483 10.351 18.7646 10.4076 18.6697 10.4338L13.1483 11.8567C12.8369 11.937 12.5526 12.0993 12.3252 12.3268C12.0977 12.5542 11.9354 12.8385 11.855 13.1499L10.4313 18.6713C10.4048 18.7659 10.3481 18.8492 10.2699 18.9085C10.1917 18.9679 10.0961 19 9.99794 19C9.89974 19 9.80423 18.9679 9.72599 18.9085C9.64775 18.8492 9.59107 18.7659 9.5646 18.6713L8.14174 13.1499Z" />
                <path class="pebbl-chip-spark-minor" d="M17.1982 1.9002V5.50011M18.9982 3.70016H15.3982" />
                <path class="pebbl-chip-spark-minor" d="M2.79858 14.4999V16.2998M3.69856 15.3999H1.8986" />
              </svg>
              <span class="pebbl-chip-label">Ask Pebbl AI</span>
            </a>
          </div>
        </ng-template>
        <ng-template #signIn>
          <button class="btn btn-secondary" type="button" (click)="openModal()">
            <span class="btn-secondary-hover"></span>
            <span class="btn-content">Sign In</span>
          </button>
        </ng-template>
        <ng-template #dropdown let-link>
          <li [class.nav-item]="link" [class.d-none]="link">
            <a [class.nav-link]="link" [class.dropdown-item]="!link" (click)="link ? toggleMenu() : null"
              [routerLink]="[ROUTES.ACCOUNT.ROOT+'/'+ROUTES.ACCOUNT.ACCOUNT_SETTINGS]">
              My Profile
            </a>
          </li>
          <li [class.nav-item]="link" [class.d-none]="link">
            <span [class.nav-link]="link" [class.dropdown-item]="!link"
              (click)="openModal(CommonConstants.AUTH_MODAL_TYPES.CHANGE_PASSWORD); link ? toggleMenu() : null">
              Change Password
            </span>
          </li>
          @if(!link) {
          <li>
            <hr class="dropdown-divider" />
          </li>
          }
          <li [class.nav-item]="link" [class.d-none]="link">
            <span [class.nav-link]="link" [class.dropdown-item]="!link" (click)="confirmLogout(); link ? toggleMenu() : null">
              Logout
            </span>
          </li>
        </ng-template>
      </div>
    </nav>
  </div>
</div>
<!--================================= Header End =================================-->
